export interface CategoryInfo {
  slug: string;
  name: string;
  icon: string;
  description: string;
  color: string;
}

export const categories: CategoryInfo[] = [
  { slug: '搞笑', name: '搞笑日常', icon: 'ri-emotion-laugh-line', description: '每日欢乐源泉，笑到停不下来', color: 'from-amber-400 to-orange-500' },
  { slug: '美食', name: '美食制作', icon: 'ri-restaurant-line', description: '舌尖上的美味，人人都能做大厨', color: 'from-red-400 to-rose-500' },
  { slug: '音乐', name: '音乐舞蹈', icon: 'ri-music-line', description: '旋律与节奏，舞动青春活力', color: 'from-purple-400 to-pink-500' },
  { slug: '旅行', name: '旅行风光', icon: 'ri-earth-line', description: '足不出户看世界，发现旅途之美', color: 'from-teal-400 to-cyan-500' },
  { slug: '科技', name: '科技数码', icon: 'ri-smartphone-line', description: '前沿科技资讯，数码产品评测', color: 'from-blue-400 to-indigo-500' },
  { slug: '舞蹈', name: '舞蹈专区', icon: 'ri-run-line', description: '潮流舞蹈，燃爆你的每一个细胞', color: 'from-pink-400 to-rose-500' },
  { slug: '时尚', name: '时尚穿搭', icon: 'ri-t-shirt-line', description: '潮流穿搭指南，做最靓的自己', color: 'from-violet-400 to-purple-500' },
  { slug: '体育', name: '体育运动', icon: 'ri-basketball-line', description: '运动激情，感受竞技的魅力', color: 'from-green-400 to-emerald-500' },
  { slug: '游戏', name: '游戏电竞', icon: 'ri-gamepad-line', description: '游戏精彩时刻，电竞高光集锦', color: 'from-sky-400 to-blue-500' },
  { slug: '知识', name: '知识科普', icon: 'ri-book-open-line', description: '涨知识，有趣有用的科普内容', color: 'from-yellow-400 to-amber-500' },
];

export interface ArticleItem {
  id: number;
  title: string;
  category: string;
  author: string;
  views: string;
  likes: string;
  duration: string;
  thumbnail: string;
  description: string;
  content: string;
}

export const articlesByCategory: Record<string, ArticleItem[]> = {
  '搞笑': [
    {
      id: 101,
      title: '爆笑合集：办公室里的那些糗事，笑到停不下来',
      category: '搞笑',
      author: '开心小达人',
      views: '1280万',
      likes: '86.5万',
      duration: '02:35',
      thumbnail: 'https://readdy.ai/api/search-image?query=Funny%20office%20comedy%20scene%20with%20colleagues%20laughing%20uncontrollably%2C%20bright%20modern%20workspace%2C%20candid%20moment%20captured%2C%20warm%20natural%20lighting%20through%20windows%2C%20clean%20minimal%20office%20interior%20with%20plants&width=640&height=800&seq=cat-funny-01&orientation=portrait',
      description: '办公室里的搞笑瞬间大合集，从打印机卡纸到咖啡洒键盘，每一幕都让人笑到肚子疼。同事们的真实反应比剧本还好笑！',
      content: '在忙碌的办公室日常中，总有一些让人捧腹大笑的瞬间。本期视频收集了来自全国各地网友投稿的办公室糗事...',
    },
    {
      id: 102,
      title: '猫咪搞笑行为大赏，铲屎官的快乐源泉',
      category: '搞笑',
      author: '喵星人日记',
      views: '980万',
      likes: '72.1万',
      duration: '01:55',
      thumbnail: 'https://readdy.ai/api/search-image?query=Adorable%20cat%20making%20funny%20face%20closeup%2C%20playful%20orange%20tabby%20cat%20with%20surprised%20expression%2C%20bright%20indoor%20setting%20with%20soft%20window%20light%2C%20cute%20pet%20photography%20style%2C%20clean%20warm%20background&width=640&height=800&seq=cat-funny-02&orientation=portrait',
      description: '铲屎官们投稿的最搞笑猫咪时刻，从摔跤到卖萌，这些毛孩子真是太会给自己加戏了！',
      content: '猫咪是这个星球上最有趣的生物之一。它们时而高冷，时而蠢萌，永远猜不透下一秒会做什么...',
    },
    {
      id: 103,
      title: '街头恶搞：路人神反应合集，笑出腹肌',
      category: '搞笑',
      author: '欢乐制造机',
      views: '1560万',
      likes: '102.3万',
      duration: '03:20',
      thumbnail: 'https://readdy.ai/api/search-image?query=Street%20prank%20scene%20with%20people%20having%20surprised%20funny%20reactions%2C%20urban%20city%20street%20background%2C%20sunny%20day%20with%20bright%20natural%20light%2C%20candid%20street%20photography%20style%2C%20clean%20composition&width=640&height=800&seq=cat-funny-03&orientation=portrait',
      description: '街头恶搞系列，路人们的神反应简直可以拿奥斯卡！有些人的反应比恶搞本身还要搞笑一百倍。',
      content: '街头恶搞系列是我们最受欢迎的栏目之一。在征得当事人同意的前提下，我们记录下了这些珍贵的反应瞬间...',
    },
    {
      id: 104,
      title: '萌娃搞笑日常，小朋友的脑回路你永远猜不到',
      category: '搞笑',
      author: '萌娃成长记',
      views: '2100万',
      likes: '145.6万',
      duration: '02:48',
      thumbnail: 'https://readdy.ai/api/search-image?query=Adorable%20toddler%20making%20silly%20face%20with%20messy%20food%2C%20bright%20cheerful%20home%20kitchen%20setting%2C%20warm%20natural%20lighting%2C%20candid%20childhood%20photography%2C%20clean%20soft%20background&width=640&height=800&seq=cat-funny-04&orientation=portrait',
      description: '小朋友们的世界真的太有趣了，他们天马行空的想象力和出其不意的行为让人又爱又笑。',
      content: '孩子们是这个世界上最纯真的存在。他们用最直接的方式表达自己，很多时候让人哭笑不得...',
    },
  ],
  '美食': [
    {
      id: 201,
      title: '五分钟学会红烧肉，大厨手把手教你做正宗家常味',
      category: '美食',
      author: '厨房小能手',
      views: '980万',
      likes: '72.3万',
      duration: '04:50',
      thumbnail: 'https://readdy.ai/api/search-image?query=Beautiful%20braised%20pork%20belly%20dish%20in%20ceramic%20bowl%20with%20steam%20rising%2C%20traditional%20Chinese%20cuisine%2C%20warm%20kitchen%20lighting%2C%20wooden%20table%20surface%2C%20food%20photography%20with%20soft%20side%20lighting&width=640&height=800&seq=cat-food-01&orientation=portrait',
      description: '大厨手把手教你做正宗红烧肉，从选肉到收汁，每一步都讲得明明白白，新手也能一次成功！',
      content: '红烧肉是一道经典的家常菜，但要做得好吃并不容易。今天我们就来分享大厨的秘制配方...',
    },
    {
      id: 202,
      title: '深夜食堂：一个人也要好好吃饭，治愈系一人食',
      category: '美食',
      author: '孤独美食家',
      views: '650万',
      likes: '48.9万',
      duration: '03:30',
      thumbnail: 'https://readdy.ai/api/search-image?query=Cozy%20solo%20dinner%20setting%20with%20simple%20Japanese%20style%20meal%20on%20wooden%20table%2C%20warm%20ambient%20lighting%20from%20above%2C%20minimalist%20interior%2C%20comfort%20food%20photography%20with%20soft%20shadows&width=640&height=800&seq=cat-food-02&orientation=portrait',
      description: '一个人也要好好吃饭！深夜食堂系列，分享简单又温暖的治愈系一人食，抚慰每一个孤独的灵魂。',
      content: '在这个快节奏的城市里，一个人吃饭似乎成了一种常态。但这并不意味着要凑合...',
    },
    {
      id: 203,
      title: '街头小吃地图：走遍全国寻找最地道的地方美味',
      category: '美食',
      author: '吃货日记',
      views: '1320万',
      likes: '89.7万',
      duration: '06:15',
      thumbnail: 'https://readdy.ai/api/search-image?query=Bustling%20Chinese%20street%20food%20market%20with%20various%20food%20stalls%20and%20steaming%20dishes%2C%20colorful%20signs%2C%20warm%20evening%20lighting%2C%20vibrant%20atmosphere%2C%20street%20photography%20style%2C%20clean%20composition&width=640&height=800&seq=cat-food-03&orientation=portrait',
      description: '从成都的串串到西安的肉夹馍，带你走遍全国各地，寻找那些藏在巷子深处的绝美街头小吃。',
      content: '中国的街头小吃文化博大精深，每个城市都有自己独特的美食记忆。这次我们跨越五千公里...',
    },
    {
      id: 204,
      title: '烘焙新手必看：零失败戚风蛋糕，松软香甜不塌陷',
      category: '美食',
      author: '烘焙时光',
      views: '780万',
      likes: '56.2万',
      duration: '05:40',
      thumbnail: 'https://readdy.ai/api/search-image?query=Perfect%20fluffy%20chiffon%20cake%20on%20elegant%20cake%20stand%2C%20golden%20brown%20surface%2C%20soft%20natural%20window%20lighting%2C%20clean%20minimal%20kitchen%20setting%2C%20baking%20photography%20with%20warm%20tones&width=640&height=800&seq=cat-food-04&orientation=portrait',
      description: '烘焙入门必学的戚风蛋糕，跟着步骤做保证零失败！松软香甜，入口即化，比外面买的还好吃。',
      content: '戚风蛋糕是烘焙入门的必修课。很多人第一次做都会遇到塌陷、开裂的问题，其实掌握了关键技巧...',
    },
  ],
  '音乐': [
    {
      id: 301,
      title: '零基础学吉他，三分钟掌握最常用的四个和弦',
      category: '音乐',
      author: '音乐教室',
      views: '720万',
      likes: '55.6万',
      duration: '03:15',
      thumbnail: 'https://readdy.ai/api/search-image?query=Closeup%20of%20hands%20playing%20acoustic%20guitar%20chords%20on%20fretboard%2C%20warm%20cozy%20room%20lighting%2C%20wooden%20interior%2C%20music%20learning%20atmosphere%2C%20soft%20natural%20light%20from%20window&width=640&height=800&seq=cat-music-01&orientation=portrait',
      description: '吉他入门必学的四个万能和弦，学会了就能弹唱大部分流行歌曲，零基础也能快速上手！',
      content: '吉他可能是最容易入门但又最难精通的乐器之一。但如果只是想弹唱几首歌，其实只需要四个和弦...',
    },
    {
      id: 302,
      title: '街头钢琴挑战：陌生路人即兴演奏惊艳全场',
      category: '音乐',
      author: '街头旋律',
      views: '1890万',
      likes: '132.4万',
      duration: '04:22',
      thumbnail: 'https://readdy.ai/api/search-image?query=Person%20playing%20public%20piano%20in%20urban%20square%20with%20passersby%20watching%2C%20golden%20afternoon%20sunlight%2C%20city%20architecture%20background%2C%20candid%20documentary%20style%20photography&width=640&height=800&seq=cat-music-02&orientation=portrait',
      description: '在街头放置一架钢琴，路过的陌生人展现惊人天赋。音乐真的可以连接每一个人的心。',
      content: '我们在城市中心的广场放置了一架钢琴，看看路过的陌生人会带来怎样的惊喜。结果让人感动...',
    },
    {
      id: 303,
      title: '一人乐队：用Loop Station创造震撼音乐现场',
      category: '音乐',
      author: '音乐魔法师',
      views: '650万',
      likes: '47.8万',
      duration: '05:05',
      thumbnail: 'https://readdy.ai/api/search-image?query=Musician%20surrounded%20by%20various%20instruments%20and%20loop%20station%20equipment%2C%20creative%20home%20studio%20with%20warm%20colorful%20lighting%2C%20indie%20music%20atmosphere%2C%20artistic%20interior&width=640&height=800&seq=cat-music-03&orientation=portrait',
      description: '一个人就是一支乐队！使用Loop Station实时录制叠加，创造出令人震撼的音乐层次。',
      content: 'Loop Station是近年来非常流行的音乐表演形式。一个人通过实时录音和循环播放...',
    },
  ],
  '旅行': [
    {
      id: 401,
      title: '城市夜景延时摄影，看见不一样的北上广深',
      category: '旅行',
      author: '光影捕手',
      views: '1560万',
      likes: '98.1万',
      duration: '01:48',
      thumbnail: 'https://readdy.ai/api/search-image?query=Stunning%20city%20night%20skyline%20with%20colorful%20neon%20reflections%20on%20water%2C%20illuminated%20skyscrapers%2C%20dramatic%20twilight%20sky%2C%20long%20exposure%20cityscape%20photography%2C%20professional%20urban%20landscape&width=640&height=800&seq=cat-travel-01&orientation=portrait',
      description: '用延时摄影的方式记录北上广深的璀璨夜景，每一帧都是壁纸级别的视觉享受。',
      content: '城市在夜晚展现出与白天完全不同的魅力。万家灯火如同地上的星河，繁华而温暖...',
    },
    {
      id: 402,
      title: '西藏自驾游全攻略：从成都到拉萨的318国道之旅',
      category: '旅行',
      author: '旅行阿杰',
      views: '1120万',
      likes: '82.3万',
      duration: '08:30',
      thumbnail: 'https://readdy.ai/api/search-image?query=Breathtaking%20Tibetan%20plateau%20landscape%20with%20snow%20capped%20mountains%20under%20clear%20blue%20sky%2C%20winding%20mountain%20road%2C%20golden%20sunlight%20on%20distant%20peaks%2C%20travel%20photography%20with%20dramatic%20scale&width=640&height=800&seq=cat-travel-02&orientation=portrait',
      description: '最详细的318国道自驾攻略，从成都出发到拉萨，沿途美景、住宿、注意事项一网打尽。',
      content: '318国道被誉为中国最美的景观大道。从成都到拉萨，2000多公里的旅程...',
    },
  ],
  '科技': [
    {
      id: 501,
      title: '科技改变生活：2025年最值得入手的智能家居推荐',
      category: '科技',
      author: '数码极客',
      views: '890万',
      likes: '63.2万',
      duration: '05:20',
      thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20smart%20home%20devices%20arranged%20on%20minimalist%20desk%2C%20clean%20white%20interior%2C%20warm%20ambient%20lighting%2C%20product%20photography%20style%20with%20soft%20shadows%2C%20contemporary%20design&width=640&height=800&seq=cat-tech-01&orientation=portrait',
      description: '2025年智能家居选购指南，从音箱到门锁，告诉你哪些值得买、哪些是智商税。',
      content: '智能家居市场每年都在快速增长，产品种类越来越多。面对琳琅满目的选择，我们帮你筛选...',
    },
    {
      id: 502,
      title: '手机摄影技巧：用一部手机拍出单反质感的照片',
      category: '科技',
      author: '手机摄影指南',
      views: '1050万',
      likes: '76.8万',
      duration: '04:15',
      thumbnail: 'https://readdy.ai/api/search-image?query=Smartphone%20photography%20setup%20with%20phone%20on%20tripod%20capturing%20beautiful%20scene%2C%20warm%20golden%20hour%20lighting%2C%20creative%20composition%2C%20modern%20minimal%20style&width=640&height=800&seq=cat-tech-02&orientation=portrait',
      description: '谁说手机拍不出好照片？掌握这些技巧，你的手机也能拍出让人惊艳的大片效果。',
      content: '现代智能手机的相机功能越来越强大，但很多人并没有发挥出它的全部潜力。今天分享10个技巧...',
    },
  ],
  '舞蹈': [
    {
      id: 601,
      title: '街舞Battle精彩集锦，高能动作燃爆全场',
      category: '舞蹈',
      author: '舞动青春',
      views: '2100万',
      likes: '135.4万',
      duration: '03:02',
      thumbnail: 'https://readdy.ai/api/search-image?query=Dynamic%20street%20dance%20performance%20with%20dancer%20doing%20power%20move%2C%20dramatic%20stage%20lighting%2C%20urban%20dance%20competition%20atmosphere%2C%20motion%20energy%2C%20vibrant%20colors&width=640&height=800&seq=cat-dance-01&orientation=portrait',
      description: '全国街舞大赛精彩集锦，Breaking、Popping、Locking各种风格的高能瞬间一次看过瘾！',
      content: '街舞文化在中国越来越受欢迎。从地下比赛到电视节目，街舞的魅力感染了无数年轻人...',
    },
  ],
  '时尚': [
    {
      id: 701,
      title: '秋季穿搭指南：用基础款打造高级感日常Look',
      category: '时尚',
      author: '穿搭日记',
      views: '760万',
      likes: '58.3万',
      duration: '04:00',
      thumbnail: 'https://readdy.ai/api/search-image?query=Stylish%20autumn%20fashion%20outfit%20flat%20lay%20with%20neutral%20tone%20clothing%2C%20minimalist%20aesthetic%2C%20warm%20soft%20lighting%2C%20clean%20white%20background%2C%20fashion%20photography%20style&width=640&height=800&seq=cat-fashion-01&orientation=portrait',
      description: '不跟风不盲从，用衣橱里的基础款搭配出高级感。秋季穿搭灵感，简约即是最美。',
      content: '每年换季都是重新审视自己衣橱的好时机。其实不需要买很多新衣服，用基础款就能搭配出多种风格...',
    },
  ],
};

export function getAllArticles(): ArticleItem[] {
  return Object.values(articlesByCategory).flat();
}

export function getArticleById(id: number): ArticleItem | undefined {
  return getAllArticles().find((a) => a.id === id);
}